import { render } from "./MediumModal.vue?vue&type=template&id=00dcf1e5&scoped=true"
import script from "./MediumModal.vue?vue&type=script&lang=js"
export * from "./MediumModal.vue?vue&type=script&lang=js"

import "./MediumModal.vue?vue&type=style&index=0&id=00dcf1e5&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00dcf1e5"]])

export default __exports__